import { cloneDeep } from 'lodash';
export var setReturnToLoginError = function (state, action) {
    var nextState = cloneDeep(state);
    nextState.returnToLoginError = action.payload;
    return nextState;
};
export var setLockedAccountUsername = function (state, action) {
    var nextState = cloneDeep(state);
    nextState.lockedAccountUsername = action.payload;
    return nextState;
};
